<template>
  <div>
    <form ref="form" :action="path" method="get" class="hd-SearchField_Form hd-Searchfield_VueForm">
      <select
        v-if="initialVendor"
        v-model="vendorPermalink"
        class="inline-select d-none d-sm-block"
      >
        <option :value="initialVendor.permalink">{{ initialVendor.name }}</option>
        <option value="">{{ t.all }}</option>
      </select>
      <input
        v-if="initialVendor && vendorPermalink"
        :value="vendorPermalink"
        type="hidden"
        name="vendor_permalink"
      />
      <input
        @input="changeCurrentValue"
        :value="currentValue"
        :placeholder="filledPlaceholder"
        @click="triggerSearchOverlay"
        autocomplete="off"
        type="text"
        name="keywords"
        class="form-control hd-SearchField_InputField"
      />
      <button class="btn hd-SearchField_SearchBtn" type="submit">
        <SearchIcon class="svg-24 svg-fill-dark" />
      </button>
    </form>
    <portal v-if="initialVendor" to="overlay-portal">
      <Overlay v-if="searchOpen" is-full-mobile class="d-sm-none">
        <SearchbarMobileOverlay
          @changeCurrentValue="changeCurrentValue"
          @setVendorPermalink="setVendorPermalink"
          :placeholder="filledPlaceholder"
          :initialVendor="initialVendor"
          :currentValue="currentValue"
          :t="t"
        />
      </Overlay>
    </portal>
  </div>
</template>

<script>
import SearchbarMobileOverlay from "./SearchbarMobileOverlay";
import Overlay from "./Overlay";
import SearchIcon from "../../icons/atalanda/search.svg";
import { toPixel } from "../utils/BreakPointMapper";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Searchbar",
  components: {
    SearchIcon,
    Overlay,
    SearchbarMobileOverlay,
  },
  props: {
    path: {
      type: String,
      required: true,
    },
    t: {
      type: Object,
      required: true,
    },
    initialValue: {
      type: String,
      default: "",
      required: false,
    },
    initialVendor: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  data() {
    return {
      currentValue: this.initialValue,
      vendorPermalink: this.initialVendor?.permalink,
    };
  },
  computed: {
    filledPlaceholder() {
      return this.vendorPermalink ? this.t.vendor_placeholder : this.t.searchbar_placeholder;
    },
    ...mapGetters({
      searchOpen: "getSearchOpenState",
    }),
  },
  methods: {
    ...mapActions({ toggleSearchState: "toggleSearchState" }),
    triggerSearchOverlay() {
      if (window.innerWidth < toPixel("sm")) {
        this.toggleSearchState();
      }
    },
    setVendorPermalink(permalink) {
      this.vendorPermalink = permalink;
      this.$nextTick(() => {
        this.$refs.form.submit();
      });
    },
    changeCurrentValue(e) {
      this.currentValue = e.target.value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.inline-select {
  font-weight: $font-weight-bold;
  font-size: $font-size-xs;
  height: auto;
  color: $gray-900;
  width: $width-select-searchfield;
  border: 0;
  outline: 0;
  padding: 0 $spacer / 2;
  padding-right: $spacer;
  text-overflow: ellipsis;
  appearance: none;
  background-color: $white;
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z' fill='currentColor'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat, repeat;
  background-position: right 0 top 50%, 0 0;
  background-size: $font-size-base auto, 100%;
}
</style>
